export default __webpack_public_path__ + "static/media/banner_login_movil.b19f4b27.jpg";